"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Legal = exports.InfographicNumber = exports.FieldBody = exports.FieldLabel = exports.Body = exports.SidebarBody = exports.SidebarProductHeader = exports.SidebarHeader = exports.DataSectionHeader = exports.SpecificityHeader = exports.SecondaryHeader = exports.Header = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Font = require("../../Constant/Font");

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.3rem;\n  font-weight: normal;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 3.2rem;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 2.2rem;\n  color: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  margin-bottom: 8px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: ", ";\n  color: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  letter-spacing: 0.023em; // .35px with 15px font\n  line-height: 1.4;\n  margin-bottom: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.5rem;\n  line-height: 1.4;\n  margin-top: 0;\n  margin-bottom: 11px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  font-size: 1.5rem;\n  font-weight: 500;\n  letter-spacing: 0.016em;\n  line-height: 1.4;\n  margin: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  text-transform: uppercase;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 400;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Header
var Header = _styledComponents.default.h1(_templateObject(), function (_ref) {
  var color = _ref.color;
  return color;
}); // application card header


exports.Header = Header;

var SecondaryHeader = _styledComponents.default.h2(_templateObject2(), function (_ref2) {
  var color = _ref2.color;
  return color;
}); // application card #


exports.SecondaryHeader = SecondaryHeader;

var SpecificityHeader = _styledComponents.default.h2(_templateObject3(), function (_ref3) {
  var color = _ref3.color;
  return color;
}); // also used to title sub-card in Escrow and Account view pages


exports.SpecificityHeader = SpecificityHeader;

var DataSectionHeader = _styledComponents.default.h4(_templateObject4());

exports.DataSectionHeader = DataSectionHeader;

var SidebarHeader = _styledComponents.default.h2(_templateObject5(), _Font.PRIMARY_FONT);

exports.SidebarHeader = SidebarHeader;

var SidebarProductHeader = _styledComponents.default.h3(_templateObject6()); // TODO: When we're ready to update the library to use the new Dashboard styles, we can use `Typography.Body` instead


exports.SidebarProductHeader = SidebarProductHeader;

var SidebarBody = _styledComponents.default.p(_templateObject7()); // body


exports.SidebarBody = SidebarBody;

var Body = _styledComponents.default.div(_templateObject8(), function (_ref4) {
  var fontWeight = _ref4.fontWeight;
  return fontWeight;
}, function (_ref5) {
  var color = _ref5.color;
  return color;
}); // CTA, menu, confirmation header


exports.Body = Body;

var FieldLabel = _styledComponents.default.h5(_templateObject9(), function (_ref6) {
  var color = _ref6.color;
  return color;
}); // confirmation body and section header


exports.FieldLabel = FieldLabel;

var FieldBody = _styledComponents.default.p(_templateObject10(), function (_ref7) {
  var color = _ref7.color;
  return color;
}); // Infographic numbers


exports.FieldBody = FieldBody;

var InfographicNumber = _styledComponents.default.p(_templateObject11(), _Font.SECONDARY_HEADER_FONT); // legal


exports.InfographicNumber = InfographicNumber;

var Legal = _styledComponents.default.span(_templateObject12());

exports.Legal = Legal;